<template>
  <div
    class="overflow-hidden rounded bg-white p-3 shadow-normal shadow-gray-400 tablet:p-5"
  >
    <figure v-if="imageUrl" class="mb-2 h-10">
      <img
        :src="imageUrl"
        :alt="title"
        loading="lazy"
        class="pointer-events-none block h-full"
      />
    </figure>
    <div class="min-h-[180px] pb-2 tablet:h-[180px] tablet:min-h-0">
      <strong
        v-if="title"
        class="text-h4 mb-2 tablet:line-clamp-2 tablet:h-14 desktop:h-16"
        :title="title"
      >
        {{ title }}
      </strong>
      <p
        v-if="description"
        class="line-clamp-3 text-sm text-gray-600"
        :title="description"
      >
        {{ description }}
      </p>
    </div>
    <div
      class="border-t border-solid border-gray-400 pt-5"
      :class="
        focusedSolutions.length <= 0 &&
        'hidden tablet:pointer-events-none tablet:block tablet:opacity-0'
      "
    >
      <strong class="text-h5 mb-2 block">
        {{ t('solutions') }}
      </strong>
      <ul class="tablet:min-h-[84px]">
        <li v-for="item in focusedSolutions" :key="hash(item)">
          <TheArrowLink
            v-if="item.url"
            :to="item.url"
            :title="item.name"
            :icon-position="'prefix'"
          >
            {{ item.name }}
          </TheArrowLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import type { IFocusedSolution } from '@/components/Shared/Carousel/types';

  interface IProps {
    title: string;
    description: string;
    imageUrl: string;
    focusedSolutions: IFocusedSolution[];
  }

  withDefaults(defineProps<IProps>(), {
    title: '',
    description: '',
    imageUrl: '',
    focusedSolutions: () => [],
  });

  const { t } = useI18n({ useScope: 'local' });
</script>

<i18n lang="json">
{
  "en-int": {
    "solutions": "Focused Solutions"
  },
  "en-jp": {
    "solutions": "Focused Solutions"
  },
  "en-tw": {
    "solutions": "Focused Solutions"
  },
  "en-kr": {
    "solutions": "Focused Solutions"
  },
  "en-americas": {
    "solutions": "Focused Solutions"
  },
  "en-asia-pacific": {
    "solutions": "Focused Solutions"
  },
  "en-emea": {
    "solutions": "Focused Solutions"
  },
  "ja-jp": {
    "solutions": "Focused Solutions"
  },
  "zh-cn": {
    "solutions": "Focused Solutions"
  },
  "zh-tw": {
    "solutions": "Focused Solutions"
  }
}
</i18n>
